module.exports = __webpack_public_path__ + "static/media/futbol.2a171538.svg";